import React, { useCallback, useEffect, useState, useMemo } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { ResponsiveContext, Button, Layer, TextArea, Box, Anchor, RadioButtonGroup, Text } from 'grommet';
import { FormClose } from 'grommet-icons';

import { ErrorForm, Placeholder } from '../../../../components';
import { TitleField, CalendarDropButton, DescriptionField } from '../../../../components/form';
import { TitleDetail, SimpleDetail, Hr } from '../../../../components/detail';
import { formattedDateTime } from '../../../../utils';

import visibleWidth from '../../../../constants/layer-width';

import { createComment, deleteComment, toggleFormCommentLayer } from '../../actions/form-comment';
import { changeValues } from '../../../../actions/form';

const FormComment = (props) => {
  const actions = useMemo(() => ({
    LIST: 'LIST',
    CREATE: 'CREATE',
  }), []);

  const [action, setAction] = useState(actions.CREATE);

  const handlePost = useCallback(formParams => {
    const {
      createComment,
    } = props;

    createComment({ formParams });
  }, [props]);

  const handleDelete = useCallback(formParams => {
    const {
      deleteComment,
      changeValues,
    } = props;

    const {
      comment,
      treatmentId,
    } = formParams;

    changeValues(
      { fieldName: 'comments', value: comment }, 'formRemoveValues'
    );

    deleteComment({
      formParams: { treatmentId, id: comment.id }
    });
  }, [props]);

  useEffect(() => {
    setAction(actions.CREATE);
  }, [
    props.toggleLayer, actions.CREATE
  ]);

  useEffect(() => {
    if (props?.comments?.length === 0) {
      setAction(actions.CREATE);
    }
  }, [props.comments, actions.CREATE]);


  const {
    usersOptions,

    treatmentId,
    reference,
    date,
    responsibleId,
    comment,
    comments,

    getServerPresponseError,
    watingServerResponse,

    toggleLayer,
    loadingPostForm,
    postDataError,

    changeValues,
    toggleFormCommentLayer,
  } = props;


  if(!toggleLayer || toggleLayer !== 'createComment') {
    return null;
  }

  return (
    <ResponsiveContext.Consumer>
      {size => (
        <Layer
          responsive={false}
          full='vertical'
          position='left'
          onClickOutside={toggleFormCommentLayer}
          onEsc={toggleFormCommentLayer}
        >
          <Box
            fill='vertical'
            width={visibleWidth[size]}
            pad={{ top: 'large', bottom: 'xsmall' }}
            overflow='auto'
            flex
          >
            {watingServerResponse && !treatmentId && !getServerPresponseError ? (
              <Placeholder
                title='Carregando...'
                message='Aguarde que estamos preparando as coisas :)'
              />
            ) : null}

            {getServerPresponseError ? (
              <Placeholder
                title='Ops! Algo deu errado :('
                message='Estamos constrangidos por isso.'
                button={{
                  label: 'Fechar',
                  action: toggleFormCommentLayer,
                }}
              />
            ) : null}

            {!getServerPresponseError && (treatmentId || !watingServerResponse) ? (
              <>
                <Box
                  direction='row'
                  justify='between'
                  align='baseline'
                  margin={{ horizontal: 'large' }}
                >
                  <TitleDetail value='Gerenciar comentários' />

                  <Button
                    plain
                    title='Fechar'
                    icon={<FormClose />}
                    onClick={toggleFormCommentLayer}
                  />
                </Box>


                <Box
                  flex
                  overflow='auto'
                >
                  <SimpleDetail
                    title='Referência'
                    value={reference}
                    description='Código do atendimento que esta comentando, fazendo anotação.'
                    width={{ title: '50vw',  value: '50vw' }}
                  />

                  <Hr />

                  <Box
                    margin={{
                      vertical: size === 'small' ? 'medium' : 'small',
                      horizontal: 'large'
                    }}
                    flex={{ shrink: 0 }}
                  >
                    <Box
                      direction='row'
                      gap='medium'
                      align='center'
                    >
                      <Anchor
                        size='small'
                        label='+ Adicionar'
                        title='Adicionar um novo comentário, anotação.'
                        disabled={ action === actions.CREATE || comments.length === 0 }
                        onClick={() =>
                          setAction(actions.CREATE)
                        }
                      />

                      <Anchor
                        size='small'
                        label='Outros comentários, anotações'
                        title={ comments.length === 0 ? 'Esse atendimento não têm comentários.' : null }
                        disabled={ action === actions.LIST || comments.length === 0 }
                        onClick={() => setAction(actions.LIST) }
                      />
                    </Box>
                  </Box>


                  { action === actions.CREATE ? (
                    <>
                      <Box
                        margin={{
                          vertical: size === 'small' ? 'medium' : 'small',
                          horizontal: 'large'
                        }}
                        flex={{ shrink: 0 }}
                      >
                        <TitleField text='Responsável' required />

                        <Box
                          round='xxsmall'
                          pad={{
                            vertical: 'small',
                          }}
                          gap='xsmall'
                        >
                          <RadioButtonGroup
                            name='responsibleId'
                            value={responsibleId ?? ''}
                            options={
                              usersOptions.filter(a => a.status).map(({ id, name }) => ({
                                label: name,
                                id: id.toString(),
                                value: id.toString(),
                              }))
                            }
                            onChange={event => {
                              changeValues({ fieldName: 'responsibleId', value: event.target.value }, 'formChangeValues')
                            }}
                          >
                            {(option, { checked }) => {
                              let background = null;
                              let borderColor = 'dark-5';

                              if(checked) {
                                background = 'brand';
                                borderColor = 'brand';
                              }

                              return (
                                <Box
                                  direction='row'
                                  gap='small'
                                  justify='center'
                                  align='center'
                                >
                                  <Box
                                    width={'20px'}
                                    height={'20px'}
                                    background={background}
                                    round='xxsmall'
                                    border={{
                                      color: borderColor
                                    }}
                                  />
                                  <Text color='dark-2' size='small'>{option.label}</Text>
                                </Box>
                              )
                            }}
                          </RadioButtonGroup>

                          <ErrorForm errorsList={postDataError.errors} fieldName='responsibleId' />
                        </Box>
                      </Box>

                      <Box
                        margin={{
                          vertical: 'small',
                          horizontal: 'large'
                        }}
                        flex={{ shrink: 0 }}
                        direction={ size === 'small' ? 'column' : 'row' }
                        align='stretch'
                        gap='small'
                      >
                        <Box
                          width={ size === 'small' ? '100vw' : '50vw'}
                          gap='xxsmall'
                        >
                          <TitleField text='Data' required />

                          <DescriptionField
                            text='Dia do comentário, anotação.'
                          />
                        </Box>

                        <Box
                          width={ size === 'small' ? '100vw' : '50vw'}
                        >
                          <CalendarDropButton
                            date={date ?? ''}
                            onSelect={(selectedDate) => changeValues({ fieldName: 'date', value: selectedDate }, 'formChangeValues')}
                          />

                          <ErrorForm errorsList={postDataError.errors} fieldName='date' />
                        </Box>
                      </Box>

                      <Box
                        margin={{
                          vertical: size === 'small' ? 'medium' : 'small',
                          horizontal: 'large'
                        }}
                        flex={{ shrink: 0 }}
                      >
                        <TitleField text='Comentário' required />

                        <TextArea
                          rows={3}
                          resize='vertical'
                          maxLength={1000}
                          value={comment ?? ''}
                          placeholder='Exemplo: Entramos em contato com a prefeitura e a mesma esta analisando.'
                          onChange={event => changeValues({ fieldName: 'comment', value: event.target.value }, 'formChangeValues')}
                        />

                        <ErrorForm errorsList={postDataError.errors} fieldName='comment' />
                      </Box>
                    </>
                  ) : null }


                  {action === actions.LIST ? (
                    <>
                      <Box
                        margin={{
                          vertical: size === 'small' ? 'medium' : 'small',
                          horizontal: 'large'
                        }}
                        flex={{ shrink: 0 }}
                      >
                        {comments.map((comment) => (
                          <Box
                            key={comment.id}
                            round='small'
                            pad={{
                              vertical: size === 'small' ? 'medium' : 'small',
                              horizontal: 'medium'
                            }}
                            margin={{ bottom: 'medium' }}
                            border={{ color: 'light-3' }}
                            fill='horizontal'
                          >
                            <Box
                              direction='row'
                              justify='between'
                              align='center'
                              gap='medium'
                            >
                              <Box
                                fill='horizontal'
                                gap='xsmall'
                              >
                                <Text size='small' color='dark-3'>{comment.description}</Text>
                                <Text size='xsmall' color='dark-5'>{formattedDateTime(comment.progressDate, 'ddd, DD MMM YYYY')}</Text>
                              </Box>

                              <Box
                                background={'status-critical'}
                                round='medium'
                                pad={{
                                  horizontal: size === 'small' ? 'small' : 'medium',
                                  vertical: size === 'small' ? 'xxsmall' : 'xxsmall',
                                }}
                              >
                                <Anchor
                                  size='small'
                                  color='white'
                                  title='Ao clicar em excluir o comentário será removido permanentemente.'
                                  label='excluir'
                                  disabled={loadingPostForm}
                                  onClick={() => handleDelete({
                                    treatmentId,
                                    comment,
                                  })}
                                />
                              </Box>
                            </Box>
                          </Box>
                        ))}
                      </Box>
                    </>
                  ) : null }
                </Box>


                {action === actions.CREATE ? (
                  <Box
                    direction='row'
                    pad={{ vertical: 'medium' }}
                    justify='center'
                    align='center'
                    gap='small'
                  >
                    <Box width='xsmall'>
                      <Anchor
                        color='dark-3'
                        label='Cancelar'
                        onClick={toggleFormCommentLayer}
                      />
                    </Box>

                    <Box width='small'>
                      <Button
                        color='brand'
                        primary
                        label={ !loadingPostForm ? 'Salvar' : 'Salvando...' }
                        disabled={ loadingPostForm }
                        onClick={() =>
                          handlePost({
                            treatmentId,
                            date: formattedDateTime(date),
                            responsibleId,
                            comment,
                          })
                        }
                      />
                    </Box>
                  </Box>
                ) : null}
              </>
            ) : null}
          </Box>
        </Layer>
      )}
    </ResponsiveContext.Consumer>
  );
}

const mapStateToProps = ({ layerReducer, selectOptionsReducer, formCreateUpdateCopyGeneric }) => ({
  usersOptions: selectOptionsReducer.usersOptions,

  treatmentId: formCreateUpdateCopyGeneric.treatmentId,
  reference: formCreateUpdateCopyGeneric.reference,
  date: formCreateUpdateCopyGeneric.date,
  responsibleId: formCreateUpdateCopyGeneric.responsibleId,
  comment: formCreateUpdateCopyGeneric.comment,
  comments: formCreateUpdateCopyGeneric.comments,

  watingServerResponse: formCreateUpdateCopyGeneric.watingServerResponse,
  getServerPresponseError: formCreateUpdateCopyGeneric.getServerPresponseError,

  loadingPostForm: formCreateUpdateCopyGeneric.loadingPostForm,
  postDataError: formCreateUpdateCopyGeneric.postDataError,

  toggleLayer: layerReducer.toggleLayer,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({
    changeValues,
    createComment,
    deleteComment,
    toggleFormCommentLayer,
  }, dispatch);

export const Comment = connect(mapStateToProps, mapDispatchToProps)(FormComment);
